import EnvelopeFilled from "../vectors/EnvelopeFilled";

export const EMAIL = "main.emran.hejazi@gmail.com";
export const CONTACTS = [
    {
        platform: "Email",
        label: EMAIL,
        link: `mailto:${EMAIL}`,
        icon: EnvelopeFilled,
    },
];
